export const mapCurrencyToSymbol = (currency: string) => {
  const lowerCaseCurrency = currency.toLowerCase();
  switch (lowerCaseCurrency) {
    case 'eur':
      return '€';
    case 'usd':
    case 'cad':
    case 'aud':
      return '$';
    case 'gbp':
      return '£';
    case 'chf':
      return 'Fr';
    case 'dkk':
    case 'sek':
      return 'kr';
    case 'hkd':
      return 'HK$';
    case 'jpy':
      return '¥';
    case 'sgd':
      return 'S$';
    default:
      return currency;
  }
};
